import { Box, Card, Grid, styled, useTheme } from '@mui/material';
import ReversePagination from 'components/ReversePagination';
import { useMemo, useState } from 'react';
import CrmCommentsItem from './CrmCommentsItem';

// CRM 전용 댓글 / 답글 리스트 (회색 배경 + 체크박스)
const CrmCommentsSection = ({
  isTablet,
  isMobile,
  postsData = [],
  ...props
}) => {
  const theme = useTheme();

  // 이미지 레이아웃과 동일한 더미 데이터
  // 메인 댓글 3개, 각 댓글당 하위 답글 2개 (총 9개 댓글)
  const defaultThreadsData = useMemo(
    () => [
      {
        id: 1,
        statusLabel: '승인됨',
        typeLabel: '댓글',
        categoryLabel: '뒷담화',
        nickname: '금싸라기',
        realName: '홍길동',
        date: '2025-12-12',
        ip: '192.124.144',
        postTitle: '이거진짜인가요?? ㅠㅠ',
        commentText:
          "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 ‘유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!",
        replies: [
          {
            id: 2,
            statusLabel: '승인됨',
            typeLabel: '답글',
            nickname: '무야호',
            realName: '김민수',
            date: '2025-12-12',
            ip: '192.124.144',
            commentText:
              "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 ‘유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!",
          },
          {
            id: 3,
            statusLabel: '승인됨',
            typeLabel: '답글',
            nickname: '무야호',
            realName: '김민수',
            date: '2025-12-12',
            ip: '192.124.144',
            commentText:
              "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 ‘유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!",
          },
        ],
      },
      {
        id: 4,
        statusLabel: '승인 대기',
        typeLabel: '댓글',
        categoryLabel: '뒷담화',
        nickname: '금싸라기',
        realName: '홍길동',
        date: '2025-12-12',
        ip: '192.124.144',
        postTitle: '이거진짜인가요?? ㅠㅠ',
        commentText:
          "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 ‘유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!",
        replies: [
          {
            id: 5,
            statusLabel: '승인 대기',
            typeLabel: '답글',
            nickname: '무야호',
            realName: '김민수',
            date: '2025-12-12',
            ip: '192.124.144',
            commentText:
              "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 ‘유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!",
          },
          {
            id: 6,
            statusLabel: '승인 대기',
            typeLabel: '답글',
            nickname: '무야호',
            realName: '김민수',
            date: '2025-12-12',
            ip: '192.124.144',
            commentText:
              "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 ‘유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!",
          },
        ],
      },
      {
        id: 7,
        statusLabel: '신고됨',
        typeLabel: '댓글',
        categoryLabel: '뒷담화',
        nickname: '금싸라기',
        realName: '홍길동',
        date: '2025-12-12',
        ip: '192.124.144',
        postTitle: '이거진짜인가요?? ㅠㅠ',
        commentText:
          "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 ‘유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!",
        replies: [
          {
            id: 8,
            statusLabel: '신고됨',
            typeLabel: '답글',
            nickname: '무야호',
            realName: '김민수',
            date: '2025-12-12',
            ip: '192.124.144',
            commentText:
              "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 ‘유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!",
          },
          {
            id: 9,
            statusLabel: '신고됨',
            typeLabel: '답글',
            nickname: '무야호',
            realName: '김민수',
            date: '2025-12-12',
            ip: '192.124.144',
            commentText:
              "저도 궁금했던 부분인데, 공고문을 다시 살펴보니 ‘유사 사업 수혜자는 제외'라는 문구가 있더라고요. 한번 확인해보시는게 좋을 것 같습니다!",
          },
        ],
      },
    ],
    []
  );

  // postsData가 넘어오면 동일한 구조(스레드 배열)라고 가정
  const threadsToUse = postsData.length > 0 ? postsData : defaultThreadsData;

  // 체크박스 선택 상태
  const [selectedIds, setSelectedIds] = useState([]);

  const handleToggleItem = (item, isChecked) => {
    setSelectedIds(prev =>
      isChecked ? [...prev, item.id] : prev.filter(id => id !== item.id)
    );
  };

  const StyledCard = styled(Card)(() => ({
    width: '100%',
    padding: '0px 0px',
    backgroundColor: 'transparent',
    borderRadius: 0,
    border: 'none',
  }));

  return (
    <StyledCard
      sx={{
        border: 'none',
        overflow: 'visible',
        ...props.sx,
      }}
    >
      <Box
        sx={{
          width: '100%',
        }}
      >
        <Box
          sx={{
            backgroundColor: '#FFFFFF',
            padding: isMobile ? '16px 14px' : '20px 18px',
            borderRadius: '18px',
            border: 'none',
          }}
        >
          {/* 댓글 스레드 리스트 (메인 댓글 3개 + 각 2개의 하위 답글)
              하위 답글은 메인 댓글과 동일한 회색 박스 안에서 렌더링 */}
          <Grid container spacing={2} pt={0}>
            {threadsToUse.map(thread => (
              <CrmCommentsItem
                key={thread.id}
                item={thread}
                checked={selectedIds.includes(thread.id)}
                onToggle={handleToggleItem}
              />
            ))}

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 2,
                width: '100%',
              }}
            >
              <ReversePagination
                totalItems={9}
                siblingCount={isMobile ? 0 : 1}
                size={isMobile ? 'small' : 'medium'}
              />
            </Box>
          </Grid>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default CrmCommentsSection;
